import React, { useState, useEffect } from "react";
import { CourseBuilderStaticData } from "../../../../../../_constants/staticData";
import { useLocation } from "react-router-dom";
import {
    Plus, Trash2, Check, ChevronDown, ChevronUp, AlertCircle,
    BookOpen, FileText, List, CheckSquare, PenLine, Info
} from "lucide-react";

const QUESTION_TYPES = [
    { value: "1", label: "Multiple Choice", desc: "One correct answer", icon: <List size={16} /> },
    { value: "3", label: "Multiple Select", desc: "More than one correct", icon: <CheckSquare size={16} /> },
    { value: "2", label: "Fill in the Blank", desc: "Short text answer", icon: <PenLine size={16} /> },
];

const Quiz = ({
    quizCreation,
    setQuizCreation,
    history,
    next,
    quizValidateMsg,
    setQuizValidateMsg,
    updateQuizResponse,
}) => {
    const location = useLocation();
    const courseID = location?.state?.courseId;

    const [quiz, setQuiz] = useState({
        title: false,
        instruction: false,
        multipleChoice: quizCreation.questions[0]?.question === null ? false : true,
        createQuestionType: [{ quizType: "" }],
    });
    const [addStatus, setAddStatus] = useState(null);
    const [questionIncrement, setQuestionIncrement] = useState(0);
    const [errors, setErrors] = useState({ answers: [] });

    const addFormFields = (id, event, property, max, prevState, errors, value, accessor = null, object) => {
        event.preventDefault();
        let clonedValues = [...quizCreation[object]];
        clonedValues[id]["answers"] = [...clonedValues[id][property], value];
        setQuizCreation({ ...quizCreation, questions: clonedValues });
    };

    const addCreateQuestion = (event, name, max, data, type) => {
        event.preventDefault();
        const optionStatus = quizCreation?.questions[quizCreation?.questions.length - 1].answers;
        const optionResult = optionStatus.map((items) => items.isRight === true);
        if (optionResult?.length >= 0) {
            setQuestionIncrement(questionIncrement + 1);
            let clonedValues = [...quizCreation["questions"]];
            let questions = [...clonedValues, data];
            setQuizCreation({ ...quizCreation, questions });
            setAddStatus(null);
        } else {
            setAddStatus("Please choose any one right answer");
        }
    };

    const removeFormFields = (id, event, index, property, name) => {
        event.preventDefault();
        let getID = [...quizCreation["questions"][id][property]];
        let newquizCreation = [...getID];
        newquizCreation.splice(index, 1);
        const clonedValues = { ...quizCreation };
        clonedValues["questions"][id][property] = newquizCreation;
        setQuizCreation(clonedValues);
    };

    const handleInputChange = (id, index, name, value, accessor = null, object) => {
        let test = { ...quizCreation[object] };
        let clonedValues = [...test[id][name]];
        bindquizCreation(index, value, clonedValues, accessor);
        const prevState = { ...quizCreation };
        prevState[object][id][name] = clonedValues;
        setQuizCreation(prevState);
    };

    const bindquizCreation = (index, value, items, accessor = null) => {
        accessor ? (items[index][accessor] = value) : (items[index] = value);
        return items;
    };

    const inputHandler = (e) => {
        const name = e.target.name;
        const values = e.target.value;
        setQuizCreation({ ...quizCreation, [name]: values });
    };

    const questionDelete = (id, object) => {
        let getID = { ...quizCreation };
        let questions = [...getID[object]];
        questions.splice(id, 1);
        let values = { ...quizCreation, questions };
        setQuizCreation(values);
        setQuestionIncrement(questionIncrement - 1);
    };

    const checkInputHandler = (id, index, name, value, accessor = null, object) => {
        let clonedValues = [...quizCreation["questions"]];
        setQuizCreation({
            ...quizCreation,
            [name]: bindquizCreation(index, value, clonedValues, accessor),
        });
    };

    useEffect(() => {
        if (courseID) {
            setQuizCreation({ ...quizCreation, id: courseID });
        }
    }, [courseID]);

    const optionStatus = (isRight, questionIndex, answerIndex, type) => {
        const thisAnswers = quizCreation["questions"][questionIndex]["answers"];
        const rightAnswerIndex = thisAnswers.findIndex((item) => item.isRight);
        if (type.toString() !== "3" && rightAnswerIndex > -1) {
            return rightAnswerIndex !== answerIndex;
        }
        return false;
    };

    const handleCreateQuestion = () => {
        if (quizCreation?.name === "") {
            setQuizValidateMsg(true);
        } else {
            setQuiz({ ...quiz, multipleChoice: !quiz.multipleChoice });
        }
    };

    const isMetaValid = quizCreation?.name !== "" || quizCreation?.guidelines !== "";

    return (
        <div className="max-w-3xl mx-auto py-6 px-4 space-y-6">
            {/* Quiz Details Card */}
            <div className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden">
                <div className="flex items-center gap-3 px-6 py-5 border-b border-slate-100">
                    <div className="bg-[#264b82]/10 p-2 rounded-xl">
                        <BookOpen size={18} className="text-[#264b82]" />
                    </div>
                    <div>
                        <h3 className="font-bold text-slate-800 text-sm">Quiz Details</h3>
                        <p className="text-slate-400 text-xs font-medium">Set the title and instructions for your quiz</p>
                    </div>
                </div>

                <div className="p-6 space-y-5">
                    {/* Title Field */}
                    <div>
                        <button
                            onClick={() => setQuiz({ ...quiz, title: !quiz.title })}
                            className="w-full flex items-center justify-between px-4 py-3 bg-slate-50 hover:bg-slate-100 border border-slate-200 rounded-xl transition-all group"
                        >
                            <div className="flex items-center gap-2.5">
                                <FileText size={15} className="text-slate-400" />
                                <span className="text-sm font-bold text-slate-700">
                                    {CourseBuilderStaticData.step18.buttonText1}
                                </span>
                                {quizCreation.name && (
                                    <span className="bg-[#264b82]/10 text-[#264b82] text-[11px] font-bold px-2 py-0.5 rounded-lg truncate max-w-[200px]">
                                        {quizCreation.name}
                                    </span>
                                )}
                            </div>
                            {quiz.title
                                ? <ChevronUp size={16} className="text-slate-400" />
                                : <ChevronDown size={16} className="text-slate-400" />
                            }
                        </button>
                        {quiz.title && (
                            <div className="mt-2">
                                <input
                                    type="text"
                                    name="name"
                                    value={quizCreation.name}
                                    placeholder="e.g. Chapter 3 Assessment"
                                    className="w-full px-4 py-3 bg-white border border-slate-200 rounded-xl text-sm font-medium text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-[#264b82]/20 focus:border-[#264b82] transition-all"
                                    onChange={inputHandler}
                                />
                            </div>
                        )}
                    </div>

                    {/* Instructions Field */}
                    <div>
                        <button
                            onClick={() => setQuiz({ ...quiz, instruction: !quiz.instruction })}
                            className="w-full flex items-center justify-between px-4 py-3 bg-slate-50 hover:bg-slate-100 border border-slate-200 rounded-xl transition-all"
                        >
                            <div className="flex items-center gap-2.5">
                                <Info size={15} className="text-slate-400" />
                                <span className="text-sm font-bold text-slate-700">
                                    {CourseBuilderStaticData.step18.buttonText2}
                                </span>
                            </div>
                            {quiz.instruction
                                ? <ChevronUp size={16} className="text-slate-400" />
                                : <ChevronDown size={16} className="text-slate-400" />
                            }
                        </button>
                        {quiz.instruction && (
                            <div className="mt-2">
                                <textarea
                                    name="guidelines"
                                    rows={4}
                                    value={quizCreation.guidelines}
                                    placeholder="Describe the rules and guidelines for this quiz..."
                                    onChange={inputHandler}
                                    className="w-full px-4 py-3 bg-white border border-slate-200 rounded-xl text-sm font-medium text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-[#264b82]/20 focus:border-[#264b82] transition-all resize-none leading-relaxed"
                                />
                            </div>
                        )}
                    </div>

                    {/* Validation message */}
                    {quizValidateMsg && quizCreation?.name === "" && (
                        <div className="flex items-start gap-3 bg-rose-50 border border-rose-100 rounded-xl px-4 py-3">
                            <AlertCircle size={16} className="text-rose-500 flex-shrink-0 mt-0.5" />
                            <div className="flex-1">
                                <p className="text-rose-700 text-sm font-bold">Quiz title is required</p>
                                <p className="text-rose-500 text-xs mt-0.5">Please add a title before creating questions.</p>
                            </div>
                            <button
                                onClick={() => setQuizValidateMsg(false)}
                                className="text-rose-400 hover:text-rose-600 transition-colors text-xs font-bold"
                            >
                                ✕
                            </button>
                        </div>
                    )}

                    {/* Create First Question Button */}
                    {!quiz.multipleChoice && (
                        <button
                            onClick={handleCreateQuestion}
                            className="w-full flex items-center justify-center gap-2 bg-[#264b82] text-white py-3.5 rounded-xl font-bold text-sm hover:bg-[#1e3a6e] transition-all shadow-lg shadow-blue-900/15 active:scale-[0.98]"
                        >
                            <Plus size={18} />
                            Create First Question
                        </button>
                    )}
                </div>
            </div>

            {/* Questions Section */}
            {quiz.multipleChoice && quizCreation?.questions?.map((element, id) => (
                <div key={id} className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden">
                    {/* Question Header */}
                    <div className="flex items-center justify-between px-6 py-4 bg-slate-50 border-b border-slate-100">
                        <div className="flex items-center gap-3">
                            <div className="w-7 h-7 rounded-lg bg-[#264b82] text-white flex items-center justify-center text-xs font-black">
                                {id + 1}
                            </div>
                            <span className="text-sm font-bold text-slate-700">Question {id + 1}</span>
                            {element.type && (
                                <span className="bg-[#264b82]/10 text-[#264b82] text-[11px] font-black uppercase tracking-wider px-2.5 py-1 rounded-lg">
                                    {QUESTION_TYPES.find(t => t.value === String(element.type))?.label || element.type}
                                </span>
                            )}
                        </div>
                        {id > 0 && (
                            <button
                                onClick={() => questionDelete(id, "questions")}
                                className="flex items-center gap-1.5 text-rose-400 hover:text-rose-600 hover:bg-rose-50 text-xs font-bold px-3 py-1.5 rounded-lg transition-all"
                            >
                                <Trash2 size={14} />
                                Remove
                            </button>
                        )}
                    </div>

                    <div className="p-6 space-y-5">
                        {/* Type Selector (shows when type not yet chosen) */}
                        {element?.type === null && (
                            <div>
                                <p className="text-xs font-black text-slate-400 uppercase tracking-widest mb-3">Select Question Type</p>
                                <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                                    {QUESTION_TYPES.map((type) => (
                                        <label
                                            key={type.value}
                                            className={`flex items-start gap-3 p-4 rounded-xl border-2 cursor-pointer transition-all ${
                                                String(element.type) === type.value
                                                    ? "border-[#264b82] bg-[#264b82]/5"
                                                    : "border-slate-100 hover:border-slate-300 bg-white"
                                            }`}
                                        >
                                            <input
                                                type="radio"
                                                name="questions"
                                                value={type.value}
                                                className="sr-only"
                                                onChange={({ target }) =>
                                                    checkInputHandler(id, id, target.name, target.value, "type", "type")
                                                }
                                            />
                                            <div className={`p-1.5 rounded-lg flex-shrink-0 mt-0.5 ${
                                                String(element.type) === type.value
                                                    ? "bg-[#264b82] text-white"
                                                    : "bg-slate-100 text-slate-500"
                                            }`}>
                                                {type.icon}
                                            </div>
                                            <div>
                                                <p className="font-bold text-slate-700 text-sm">{type.label}</p>
                                                <p className="text-slate-400 text-xs mt-0.5">{type.desc}</p>
                                            </div>
                                        </label>
                                    ))}
                                </div>
                            </div>
                        )}

                        {/* Question content when type is chosen */}
                        {element?.type !== null && (
                            <>
                                {/* Question Text */}
                                <div>
                                    <label className="text-xs font-black text-slate-400 uppercase tracking-widest block mb-2">
                                        Question Text
                                    </label>
                                    <textarea
                                        name="questions"
                                        rows={3}
                                        value={element.question || ""}
                                        placeholder="Type your question here..."
                                        className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-sm font-medium text-slate-800 placeholder:text-slate-400 focus:outline-none focus:bg-white focus:ring-2 focus:ring-[#264b82]/20 focus:border-[#264b82] transition-all resize-none leading-relaxed"
                                        onChange={({ target }) =>
                                            checkInputHandler(id, id, target.name, target.value, "question", "question")
                                        }
                                    />
                                </div>

                                {/* Answer Options */}
                                {element.type !== "Detailed Q&A" && (
                                    <div>
                                        <label className="text-xs font-black text-slate-400 uppercase tracking-widest block mb-3">
                                            Answer Options
                                        </label>
                                        <div className="space-y-2.5">
                                            {element?.answers?.map((item, index) => (
                                                <div key={index} className={`flex items-center gap-3 p-3 rounded-xl border-2 transition-all ${
                                                    item.isRight
                                                        ? "border-emerald-300 bg-emerald-50"
                                                        : "border-slate-100 bg-white hover:border-slate-200"
                                                }`}>
                                                    {/* Option letter */}
                                                    <div className={`w-7 h-7 rounded-lg flex items-center justify-center text-xs font-black flex-shrink-0 ${
                                                        item.isRight ? "bg-emerald-500 text-white" : "bg-slate-100 text-slate-500"
                                                    }`}>
                                                        {item.isRight ? <Check size={14} strokeWidth={3} /> : String.fromCharCode(65 + index)}
                                                    </div>

                                                    {/* Text input */}
                                                    <input
                                                        type="text"
                                                        name="answers"
                                                        placeholder={`Option ${index + 1}`}
                                                        value={item.answer}
                                                        className={`flex-1 bg-transparent text-sm font-medium focus:outline-none placeholder:text-slate-300 ${
                                                            item.isRight ? "text-emerald-800" : "text-slate-700"
                                                        } ${
                                                            errors.answers.filter((e) => e.id === index).length > 0
                                                                ? "text-rose-600"
                                                                : ""
                                                        }`}
                                                        onChange={({ target }) =>
                                                            handleInputChange(id, index, target.name, target.value, "answer", "questions")
                                                        }
                                                    />

                                                    {/* Correct toggle */}
                                                    <label className="flex items-center gap-1.5 cursor-pointer flex-shrink-0">
                                                        <div className="relative">
                                                            <input
                                                                type="checkbox"
                                                                className="peer sr-only"
                                                                checked={item.isRight}
                                                                disabled={optionStatus(item.isRight, id, index, element?.type)}
                                                                onChange={({ target }) =>
                                                                    handleInputChange(
                                                                        id, index, "answers",
                                                                        item.isRight === false ? true : false,
                                                                        "isRight", "questions"
                                                                    )
                                                                }
                                                            />
                                                            <div className={`w-5 h-5 rounded-md border-2 flex items-center justify-center transition-all ${
                                                                item.isRight
                                                                    ? "bg-emerald-500 border-emerald-500"
                                                                    : "bg-white border-slate-300 hover:border-slate-400"
                                                            } ${optionStatus(item.isRight, id, index, element?.type) ? "opacity-40 cursor-not-allowed" : "cursor-pointer"}`}>
                                                                {item.isRight && <Check size={12} className="text-white" strokeWidth={3} />}
                                                            </div>
                                                        </div>
                                                        <span className={`text-[11px] font-bold ${item.isRight ? "text-emerald-600" : "text-slate-400"}`}>
                                                            Correct
                                                        </span>
                                                    </label>

                                                    {/* Remove option */}
                                                    {index > 0 && (
                                                        <button
                                                            name="answers"
                                                            onClick={(event) =>
                                                                removeFormFields(id, event, index, event.target.name, "answer", "questions")
                                                            }
                                                            className="text-slate-300 hover:text-rose-400 transition-colors p-1 rounded-lg hover:bg-rose-50 flex-shrink-0"
                                                        >
                                                            <Trash2 size={14} />
                                                        </button>
                                                    )}
                                                </div>
                                            ))}
                                        </div>

                                        {/* Add Option */}
                                        <button
                                            name="answers"
                                            onClick={(event) =>
                                                addFormFields(id, event, event.target.name, 5, quizCreation, errors, { answer: "", isRight: false }, true, "questions")
                                            }
                                            className="mt-3 flex items-center gap-2 text-[#264b82] hover:text-[#1e3a6e] text-sm font-bold px-3 py-2 rounded-xl hover:bg-[#264b82]/8 transition-all"
                                        >
                                            <Plus size={15} />
                                            Add Option
                                        </button>
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                </div>
            ))}

            {/* Add Question Button */}
            {quiz.multipleChoice && addStatus && (
                <div className="flex items-center gap-2.5 bg-amber-50 border border-amber-100 rounded-xl px-4 py-3">
                    <AlertCircle size={16} className="text-amber-500 flex-shrink-0" />
                    <p className="text-amber-700 text-sm font-bold">{addStatus}</p>
                </div>
            )}

            {quiz.multipleChoice &&
                quizCreation?.questions[questionIncrement]?.question !== null &&
                quizCreation?.questions?.length > 0 && (
                    <button
                        onClick={(event) =>
                            addCreateQuestion(event, "quiz", 10, {
                                question: null,
                                type: null,
                                answers: [{ answer: "", isRight: false }],
                            })
                        }
                        className="w-full flex items-center justify-center gap-2 bg-white border-2 border-dashed border-slate-300 text-slate-600 hover:border-[#264b82] hover:text-[#264b82] hover:bg-[#264b82]/5 py-4 rounded-2xl font-bold text-sm transition-all active:scale-[0.98]"
                    >
                        <Plus size={18} />
                        Add Question {quizCreation?.questions?.length + 1}
                    </button>
                )}
        </div>
    );
};

export default Quiz;
